import URL from "url-parse";
import _ from "lodash";
import api from "../../api";
import { make } from "vuex-pathify";
import { queryToFilters } from "./listings/helpers";

// initial state
const initialState = {
    listings: {},
    isLoading: false,
    isError: false,
    initialLoad: true,
    availableSortOptions: {
        priceDesc: "price,desc",
        priceAsc: "price,asc",
        paymentDesc: "quote.monthlyPayment,desc",
        paymentAsc: "quote.monthlyPayment,asc",
        savingsDesc: "savings,desc",
        relevance: "relevance"
    },
    defaultSortOption: "relevance"
};

const mutations = {
    ...make.mutations(initialState)
};

const resetToFirstPage = ({ commit, rootState }) => {
    const newPageable = {};
    const currentPageable = _.get(rootState, "vehicleSearch.pageable", null);

    Object.assign(newPageable, currentPageable, {
        page: 1
    });

    commit("vehicleSearch/SET_PAGEABLE", newPageable, { root: true });
};

const defaultSearchOpts = () => {
    return {
        // searches by default should start from the first page
        resetToFirstPage: true
    };
};
const resolveSearchOpts = opts => {
    const resolvedOpts = {};
    Object.assign(resolvedOpts, defaultSearchOpts(), opts);

    return resolvedOpts;
};
const loadListings = ({ commit, state, rootState }, opts) => {
    if (state.isLoading) {
        return;
    }
    const _opts = resolveSearchOpts(opts);

    const currentPage = _.get(rootState, "vehicleSearch.pageable.page", 1);
    if (_opts.resetToFirstPage === true && currentPage !== 1) {
        resetToFirstPage({ commit, state, rootState });
    }

    const userZipCode = _.get(
        rootState,
        "location.selectedLocation.zipCode",
        null
    );

    if (userZipCode == null) {
        commit("SET_LISTINGS", {});
        commit("SET_IS_LOADING", false);
        commit("SET_IS_ERROR", true);
        return;
    }

    commit("SET_IS_LOADING", true);

    const url = new URL(window.location.href, true);
    const currentPageable = _.get(rootState, "vehicleSearch.pageable", null);
    const currentFilters = _.get(rootState, "vehicleSearch.filters", null);

    if (state.initialLoad) {
        // set state to url
        const newFilters = {};
        const queryFilters = queryToFilters(currentFilters, url.query);
        Object.assign(newFilters, currentFilters, queryFilters);

        newFilters.stockTypes = ["NEW"];

        const newPageable = {};
        const queryPageable = queryToFilters(currentPageable, url.query);
        const currentSortOption = _.get(queryPageable, "sort", null);

        if (isSortAvailable(currentSortOption, state.availableSortOptions)) {
            // change to default value
            Object.assign(queryPageable, { sort: state.defaultSortOption });
        }

        Object.assign(newPageable, currentPageable, queryPageable);
        newPageable.page = parseInt(newPageable.page);

        commit("SET_INITIAL_LOAD", false);
        commit("vehicleSearch/SET_INITIAL_STOCK_TYPE", newFilters.stockTypes, {
            root: true
        });
        commit("vehicleSearch/INITIALIZE_FILTERS", newFilters, { root: true });
        commit("vehicleSearch/SET_PAGEABLE", newPageable, { root: true });
    }

    // always get the filters again because they may have been changed by the initial load
    const activeFilters = _.get(rootState, "vehicleSearch.filters", null);
    const activePageable = _.get(rootState, "vehicleSearch.pageable", null);
    const cleanFilters = _.omitBy(
        activeFilters,
        value => _.isNil(value) || (_.isArray(value) && _.isEmpty(value))
    );

    api.post(
        `/models/search?page=${activePageable.page}&sort=${activePageable.sort}`,
        {
            ...cleanFilters,
            zipCode: userZipCode
        }
    )
        .then(response => {
            commit("SET_LISTINGS", response.data.modelGroups);
            commit("vehicleSearch/SET_FACETS", response.data.facets, {
                root: true
            });
            commit(
                "vehicleSearch/SET_PAGE_METADATA",
                response.data.pageMetadata,
                { root: true }
            );
            // commit('SET_CLOSEST_VEHICLE', _.get(response.data, 'closestVehicle', 0));
            commit("SET_IS_LOADING", false);
            commit("SET_IS_ERROR", false);
            commit("vehicleSearch/SET_PUSH_HISTORY", true, { root: true });

            const totalVehicles = _.get(
                response.data,
                "pageMetadata.totalElements",
                0
            );
            const currentDistance = _.get(
                rootState,
                "vehicleSearch.filters.distance"
            );
            const distanceLocked =
                _.get(rootState, "vehicleSearch.distanceLocked", false) ||
                false;

            if (
                !distanceLocked &&
                totalVehicles === 0 &&
                currentDistance !== -1
            ) {
                // Expand search nationwide
                const newFilters = {};
                Object.assign(newFilters, activeFilters, {
                    distance: -1
                });
                commit("vehicleSearch/INITIALIZE_FILTERS", newFilters, {
                    root: true
                });
                return;
            }

            const totalPages =
                _.get(response, "data.pageMetadata.totalPages", 1) || 1;

            if (currentPageable.page > totalPages) {
                const newPageable = {};
                Object.assign(newPageable, currentPageable, {
                    page: totalPages
                });

                commit("vehicleSearch/SET_PAGEABLE", newPageable, {
                    root: true
                });
            }
        })
        .catch(() => {
            commit("SET_IS_LOADING", false);
            commit("SET_IS_ERROR", true);
        });
};
// actions
const actions = {
    handleZipCodeChanged: loadListings,
    handleFiltersChanged: loadListings,
    handleLoadInitialListings({ commit, state, rootState }) {
        loadListings({ commit, state, rootState }, { resetToFirstPage: false });
    },
    ...make.actions(initialState)
};

function isSortAvailable(sort, availableSortOptions) {
    return !_.find(availableSortOptions, function(option) {
        return option === sort;
    });
}

export default {
    namespaced: true,
    state: initialState,
    mutations,
    actions
};
